import { render } from "./CreateProductReviewForm.vue?vue&type=template&id=547d3d5c"
import script from "./CreateProductReviewForm.vue?vue&type=script&lang=js"
export * from "./CreateProductReviewForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__